import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef} from '@angular/core';
import {ResourceType, WizardApplicationType} from '../../../core/helpers/Const';
import {EventService} from "../../../service/services/misc/event/event.service";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {Subscription} from "rxjs";
import {SavedFilterView} from "../../../service/services/misc/saved-filter-views/saved-filter-views.service";

@Component({
    selector: 'app-panel-header',
    templateUrl: './panel-header.component.html',
    styleUrls: ['./panel-header.component.scss'],
    standalone: false
})
export class PanelHeaderComponent implements OnInit, OnDestroy {
    @Input() glyph: IconProp;
    @Input() text: string;
    @Input() isLiveSearch = true;
    @Output() createItem = new EventEmitter<any>();
    @Output() createApplication = new EventEmitter<WizardApplicationType>();

    @Output() createGenericResource = new EventEmitter<ResourceType>();
    @Output() createServiceInstance: EventEmitter<any> = new EventEmitter<any>();
    @Input() showCreateMenu = false;
    @Input() showCreateYAML = false;
    @Input() showCreateFolder = false;
    @Input() showCreateResourceGroup = false;
    @Input() showCreateManagedService = false;
    @Input() showCreateServiceInstance = false;
    @Input() showCreateApplication = false;
    @Input() body: TemplateRef<any>;
    @Input() resourceType: ResourceType;
    @Input() systemResourcesByGroup: any[];
    @Input() applicationResources: any[];
    @Input() loadingFinished = false;
    @Input() currentOrg: string;
    @Input() currentPath: string;
    @Input() advancedSearchOpen = false;
    @Input() advancedSearchReady = false;
    @Input() resultCount: number = 0;
    @Input() filterViewName: string = 'Standard';
    @Input() organizationPath?: string;
    @Input() savedFilterViewsDisabled = false;
    @Output() doSearch: EventEmitter<any> = new EventEmitter<any>();
    @Output() advancedSearchToggled: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() viewSelected = new EventEmitter<SavedFilterView>();
    isResourceValid = true;
    eventServiceSubscription: Subscription;

    constructor(private eventService: EventService) {
    }

    onDoSearch(searchTerm: string): void {
        this.doSearch.emit(searchTerm);
    }

    onCreateItem(resourceType: ResourceType) {
        this.createItem.emit(resourceType);
    }

    onCreateApplication(applicationType: WizardApplicationType) {
        this.createApplication.emit(applicationType);
    }

    onCreateGenericResource() {
        this.createGenericResource.emit();
    }

    onCreateServiceInstance(resource?: any) {
        this.createServiceInstance.emit(resource);
    }

    onAdvancedSearchToggled(isOpen: boolean) {
        this.advancedSearchToggled.emit(isOpen);
    }

    onViewSelected(view: SavedFilterView): void {
        this.viewSelected.emit(view);
    }

    ngOnInit(): void {
        this.eventServiceSubscription = this.eventService.pageLoadEventListener().subscribe((msg: string) => {
            this.isResourceValid = msg !== 'error';
        });
    }

    ngOnDestroy() {
        if (this.eventServiceSubscription) {
            this.eventServiceSubscription.unsubscribe();
        }
    }
}
